import { isNumber, isNaN, isEmpty } from 'lodash';

export function isBlank(value) {
    return (isEmpty(value) && !isNumber(value)) || isNaN(value);
}
